import { useSideNavHotkeys } from '@/hooks/useSideNavHotkeys';

export const SideNavHotkeys = () => {
  useSideNavHotkeys();
  return null;
};
